export default import.meta.ROLLDOWN_FILE_URL_yoSr7Nv$CnO5MAToQ6URdQ